import { render } from "./UserClientItem.vue?vue&type=template&id=020ce8dc&scoped=true&ts=true"
import script from "./UserClientItem.vue?vue&type=script&lang=ts"
export * from "./UserClientItem.vue?vue&type=script&lang=ts"

import "./UserClientItem.vue?vue&type=style&index=0&id=020ce8dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020ce8dc"]])

export default __exports__